import { Delete } from "@mui/icons-material";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export function BookingApprovalTopToolbar({
  disabled,
  onClick
}: Readonly<{
  disabled: boolean;
  onClick: () => void;
}>) {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", gap: "0.5rem" }}>
      <Tooltip
        title={<Typography>{t("Delete selection")}</Typography>}
        aria-label={"Delete selection"}
      >
        <span>
          <IconButton
            color="error"
            data-testid="handle-inactivate-booking-btn"
            disabled={disabled}
            onClick={onClick}
          >
            <Delete />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
}
